import { __extends } from "tslib";
import { ASError } from '@awayfl/avm2';
var MemoryError = /** @class */ (function (_super) {
    __extends(MemoryError, _super);
    function MemoryError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    MemoryError.classInitializer = null;
    // List of static symbols to link.
    MemoryError.classSymbols = null; // [];
    // List of instance symbols to link.
    MemoryError.instanceSymbols = null; // [];
    return MemoryError;
}(ASError));
export { MemoryError };
